import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { createTheme } from "@material-ui/core/styles";
import {
  Autocomplete,
  Box,
  Button,
  TextareaAutosize,
  TextField,
} from "@mui/material";
import {
  GetAllPhysicians,
  GetEmployeeGroups,
  InsertPPLogs,
  SendMessage,
} from "../../../../api"; //FB 9639
import useMediaQuery from "@mui/material/useMediaQuery";
import { Recipient } from "../../../../store";  //FB 9639

// Update log
// FB  6192   02/06/2023  DK   Added page to send New Message to Physicians
// FB  6998   06/22/2023  SK  PP - appointment should be listed in Desc. For secure sand simple message adding line break issue
// FB  9639   12/02/2024  DK  Employee Groups that are Set to be Portal Addressees.

export default function ChatMsg(props: any) {
  const matches = useMediaQuery("(min-width:600px)");
  //FB 9639 Removed unnecessary code and added few variables - Start
  const [selectedRecipient, setSelectedRecipient] = useState<Recipient>();
  const [errorCard, setErrorCard] = useState(false);
  const [sentcard, setSentcard] = useState(false);
  const [subject, setSubject] = useState("");
  const [content, setContent] = useState("");
  const [recipients, setRecipients] = useState<Recipient[]>([]);
  //FB 9639 Removed unnecessary code and added few variables - End
  const navigate = useNavigate();
  const handleClose = () => {
    setSentcard(false);
    setErrorCard(false);
  };
  const handleMailClose = () => {
    setSentcard(false);
    window.location.reload();
  };
  const JSAlert = require("js-alert");

  //FB 9639 Start
  const FinalEmail = async (event: any) => {
    let selectedPhysicianID: number;

    if (subject == null || subject == "") {
      JSAlert.alert("Please enter Subject", null, JSAlert.Icons.Warning);
    } else if (content == null || content == "") {
      JSAlert.alert("Please enter Message", null, JSAlert.Icons.Warning);
    } else if (selectedRecipient == undefined || selectedRecipient == null) {
      JSAlert.alert(
        "Select Physician To Continue",
        null,
        JSAlert.Icons.Warning
      );
    } else if (selectedRecipient != null || selectedRecipient != undefined) {
      //FB 6998 - Start
      let updatedContent = content.replace(/\n\r?/g, "<br/>");
      var data = await SendMessage(patientID, selectedRecipient.ID, subject, updatedContent, selectedRecipient.Is_Group); //FB 8638
      //FB 6998 - End
      setSentcard(true);
      //FB 8638
      InsertPPLogs(
        "Clicked on Send - Secure Mail",
        window.location.href,
        userName,
        "To Office ( " + selectedRecipient.Name + " )",
        "Sent successfully"
      );
    }
  };
  //FB 9639 End

  let patientName = "User";
  let userName: any;
  let patientID: number;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
    patientID = JSON.parse(data).Patient_n;
  }

  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });

  async function InsertLogs() {
    InsertPPLogs("Viewing Secure Mail", window.location.href, userName, "");
  }

  //FB 9639 Start
  async function GetRecipients() {
    var userInfo = sessionStorage.getItem("user");
    if (userInfo != null) {
      const user = JSON.parse(userInfo);
      if (user.Patient_n != null) {
        var physicians = await GetAllPhysicians();
        var filteredPhysicians = physicians.filter((x: any, idx: number) => idx < 50);
        var physicianRecipients: Recipient[] = filteredPhysicians.map((physician: any) => { return { ID: physician.ID, Name: physician.Name, Is_Group: false } as Recipient });
        var groups = await GetEmployeeGroups();
        var groupRecipients: Recipient[] = groups.map((group: any) => { return { ID: group.id, Name: group.groups_name, Is_Group: true } as Recipient });
        let recipients = physicianRecipients.concat(groupRecipients);
        setRecipients(recipients);
      }
    }
  }

  useEffect(() => {
    GetRecipients();
    InsertLogs();
  }, []);
  //FB 9639 End

  return (
    <div>
      <div
        className="row"
        style={{
          marginTop: matches == false ? "" : "90px",
          marginBottom: "30px",
        }}
      >
        <div className="col-sm-12">
          <div className="card" style={stylestop.container}>
            <div className="card-body">
              <p className="card-title" style={{ textAlign: "left" }}>
                <strong> New Message</strong>
              </p>
              <hr></hr>
              <div className="row">
                <span style={{ width: "55px" }}>
                  <strong>To :</strong>{" "}
                </span>
                {/* FB 9639 Start */}
                <Autocomplete
                  id="free-solo-demo"
                  size="small"
                  disableClearable
                  value={selectedRecipient}
                  getOptionLabel={(option) => option.Name}
                  options={recipients}
                  groupBy={(option) => option.Is_Group ? "Recipient Groups" : "Recipients"}
                  style={{ width: matches == false ? "80%" : "90%" }}
                  onChange={(event, value) => setSelectedRecipient(value)}
                  renderInput={(params) => {
                    const InputProps = {
                      ...params.InputProps,
                      disableUnderline: true,
                    };
                    InputProps.endAdornment = null;

                    return (
                      <TextField
                        variant="standard"
                        {...params}
                        InputProps={InputProps}
                      />
                    );
                  }}
                  openOnFocus
                />
                {/* FB 9639 End */}
              </div>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <strong>Subject : </strong>{" "}
                <input
                  id="standard-basic"
                  value={subject}
                  onChange={(e: any) => {
                    setSubject(e.target.value);
                  }}
                  style={{
                    width: matches == false ? "300px" : "400px",
                    borderColor: "transparent",
                    border: "none",
                    outline: "none",
                  }}
                ></input>{" "}
              </p>
              <hr></hr>
              <p className="card-text" style={{ textAlign: "left" }}>
                <p className="card-text" style={{ textAlign: "left" }}>
                  <strong>Message: </strong>{" "}
                </p>
              </p>
              <div className="col-sm-12">
                <TextareaAutosize
                  aria-label="minimum height"
                  minRows={8}
                  style={{
                    height: "200px",
                    width: "calc(100% - 5px)",
                  }}
                  value={content}
                  onChange={(e: any) => {
                    setContent(e.target.value);
                  }}
                />
              </div>
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={FinalEmail}
              >
                Send
              </Button>{" "}
              {""}
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#13607C",
                  color: "white",
                }}
                onClick={() => navigate("/user/home/dashboard")}
              >
                Cancel
              </Button>
              <Dialog open={sentcard} onClose={handleClose}>
                <DialogContent
                  style={{
                    maxWidth: "850px",
                    height: "150px",
                  }}
                >
                  {/* FB 9639 */}
                  <h5 style={{ textAlign: "center" }}>
                    Message Sent Successfully To {selectedRecipient?.Name}
                  </h5>
                  <br></br>
                  <Box display="center" justifyContent="center">
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "#13607C",
                        color: "white",
                      }}
                      onClick={handleMailClose}
                    >
                      Ok
                    </Button>
                  </Box>
                </DialogContent>
              </Dialog>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
const button = {
  container: {
    backgroundColor: "#13607C",
    color: "white",
  },
};
const stylestart = {
  container: {
    border: "1px grey",
    margin: "20px",
  },
};
const stylestop = {
  container: {
    height: "auto",
    border: "1px grey",
  },
};
const keybaord = {
  container: {
    fontSize: "10px",
  },
};
